"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Utility for getting the write direction in the browser which checks is the browser is Safari.
 */
var SafariWriteDirectionUtility = /** @class */ (function () {
    function SafariWriteDirectionUtility() {
    }
    /**
     * Gets write direction.
     *
     * @returns Write direction.
     * @param element Html element.
     */
    SafariWriteDirectionUtility.getWriteDirection = function (element) {
        if (navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0) {
            return document.defaultView.getComputedStyle(element, null).direction || 'ltr';
        }
        return null;
    };
    return SafariWriteDirectionUtility;
}());
exports.default = SafariWriteDirectionUtility;
//# sourceMappingURL=SafariWriteDirectionUtility.js.map